<template>
  <div>
    <div class="preSessionCart">
      <div class="presessionTitle">
        جلسه ارزیـــابی
        <br>
        قــــدم اول مسیــــــر تو
      </div>
      <div class="presessionContent">
        قبل از شروع تراپی، توی یه جلسه رایگان با کارشناس سیمیاروم صحبت کن
        <br v-if="$vuetify.breakpoint.mdAndUp">
        تا مشاور مناسب خودت رو راحت‌تر پیدا کنی.
      </div>
      <div class="">
        <v-btn class="preSessionAction mt-3" :to="{name:'newPresession'}" elevation="0">
          درخواست جلسه ارزیابی
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import AuthMixins from "@/mixins/AuthMixins";
import {mapGetters} from "vuex";

export default {
  mixins: [AuthMixins],
  props: {
    imageSource: {
      type: String
    }
  },
  computed: {
    ...mapGetters({
      'profile': 'getProfile',
    }),
    user() {
      return JSON.parse(JSON.stringify(this.profile));
    },
    sessions() {
      return this.profile.four_future_sessions
    }
  },
  data() {
    return {
      window: 1,
      phone: null,
      country_id: null,
    }
  },
  mounted() {
    this.phone = this.user.cel
  },

  methods: {
    changeWindow() {
      // this.window = 2
      // return;
      if (this.phone) {
        if (this.user.country_name) {
          this.redirectToPreSession(this.phone.replaceAll(' ', ''))
        } else {
          this.window = 3;
        }
      } else {
        this.window = 2;
      }
    },
    redirectToPreSession() {
      this.$emitEvent('setLoading', true)
      this.requesting('session', 'getPreSessionPackage', {}, {refer: 'panel'}).then((resp) => {
        if (resp.data.continue) {
          this.$router.push({name: 'onboarding_new', params: {lang: 'fa'}})
        } else {
          this.$emitEvent('notify', {title: 'درخواست شما برای جلسه پیش‌مشاوره ثبت‌ شد.', color: 'green'})
          this.window = 1
        }
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
      // const parsedNumber = parsePhoneNumberFromString(phone);
      // if (parsedNumber.country == 'IR') {
      // } else {
      //
      // }
    },

    submitPhone() {
      console.log('hrere')
      if (this.$refs.phoneForm.validate()) {
        let data = {
          mobile: this.phone.replaceAll(' ', ''),
        }
        this.$emitEvent('setLoading', true)

        this.requesting('auth', 'editProfile', '', data).then(() => {
          if (this.user.country_name) {
            this.redirectToPreSession()
          } else {
            this.window = 3
          }
        }).finally(() => {
          this.$emitEvent('setLoading', false)
        })

      }
    },

    submitCountry() {

      if (this.$refs.country.validate()) {

        let country = this.contires.find(item => item.id == this.country_id)

        let data = {
          "country_id": this.country_id,
          "country_name": country.label
        }

        this.$emitEvent('setLoading', true)

        this.requesting('auth', 'editProfile', '', data).then(() => {
          this.redirectToPreSession()
        }).finally(() => {
          this.$emitEvent('setLoading', false)
        })

      }
    }
  },


}
</script>

<style scoped>
@media (min-width: 200px) and (max-width: 800px) {
  .preSessionCart {
    background: url("../../assets/newPreSession/cart/mobile.png") !important;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100% !important;
  }
  .presessionTitle{
    font-size: 20px !important;
  }

  .presessionContent{
    font-size: 15px !important;
  }
  .preSessionAction{
    width: 143px !important;
    height: 40px !important;
    font-size: 12px !important;
  }
}

.preSessionCart {
  background: url("../../assets/newPreSession/cart/desktop.png");
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  width: 618px;
  padding: 24px 24px 191px 24px;
  flex-direction: column;
  align-items: flex-start;
  height: 355px;
  border-radius: 16px;
}

.presessionTitle {
  font-size: 23px;
  font-family: bold !important;
}

.presessionContent {
  margin-top: 15px;
  line-height: 23pt;
}

.preSessionAction {
  color: #FFF !important;
  font-size: 14px;
  display: flex;
  width: 200px ;
  height: 48px ;
  font-family: bold !important;
  padding: 0px 16px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: #39C990 !important;
  border-radius: 8px !important;
}
</style>
